export const searchPeopleActionTypes = {
    'PAGE_INIT': 'SEARCH_PEOPLE_PAGE_INIT',
    'PAGE_NEXT': 'SEARCH_PEOPLE_PAGE_NEXT',
    'PAGE_PREVIOUS': 'SEARCH_PEOPLE_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'SEARCH_PEOPLE_PAGE_REQUEST',
    'PAGE_SUCCESS': 'SEARCH_PEOPLE_PAGE_SUCCESS',
    'PAGE_ERROR': 'SEARCH_PEOPLE_PAGE_ERROR',
    'TOGGLE_SELECTION': 'SEARCH_PEOPLE_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'SEARCH_PEOPLE_CLEAR_SELECTION',
    'TOGGLE_ALL': 'SEARCH_PEOPLE_TOGGLE_ALL',
    'ADD_FILTER': 'SEARCH_PEOPLE_ADD_FILTER',
    'REMOVE_FILTER': 'SEARCH_PEOPLE_REMOVE_FILTER',
};